'use strict'

const withFedopsInteractionAsync = (
  fedopsLogger,
  tracer,
  interactionName,
  fn
) => (...args) => {
  const { timeoutId } = fedopsLogger.interactionStarted(interactionName)
  const traceEnd = tracer.trace({
    action: interactionName,
    message: ''
  })

  const promise = fn(...args)
  promise
    .then(() => {
      fedopsLogger.interactionEnded(interactionName, { timeoutId })
      traceEnd()
    })
    .catch(e => traceEnd({ message: e }))
  return promise
}

module.exports.withFedopsInteractionAsync = withFedopsInteractionAsync



// WEBPACK FOOTER //
// ./fedops/fedopsWrapper.js